import React from 'react';
import get from 'lodash/get';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import FileInput from '../../file-input';
import UploadIllustration from './upload-illustration';
import css from './upload-input-state.module.scss';
import messages from '../messages';

type Props = {
  canDrop: boolean;
  hasItems: boolean;
  intl: IntlShape;
  isDisabled: boolean;
  isOver: boolean;
  onSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const UploadInputState = (props: Props) => {
  const { intl, isOver, canDrop, isDisabled, hasItems, onSelect } = props;

  const fullClassName = classNames(css.uploadInputState, {
    [css.uploadInputStateHasItems]: hasItems,
    [css.uploadInputStateIsOver]: !isDisabled && isOver,
    [css.uploadInputStateIsDisabled]: isDisabled,
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2339
    [css.uploadInputStateCannotDrop]: !canDrop,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (
      isDisabled ||
      !onSelect ||
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2531
      get(event, ['target', 'files'], []).length === 0
    ) {
      return;
    }
    onSelect(event);
    const currentTarget = event.currentTarget as HTMLInputElement;
    // resets the file input selection
    currentTarget.value = '';
  };

  return (
    <div className={fullClassName}>
      <UploadIllustration />
      <div className={css.dndMsgLabel}>
        {intl.formatMessage(messages.dragDropMessage)}
      </div>
      <FileInput
        className={css.fileInput}
        inputLabel={intl.formatMessage(messages.selectFile)}
        isDisabled={isDisabled}
        isMultiple
        onChange={handleChange}
      />
    </div>
  );
};

export { UploadInputState };
type WrappedProps = Omit<Props, 'intl'>;
const Wrapped = injectIntl(UploadInputState);
export default Wrapped as React.ComponentType<WrappedProps>;
